module.exports = __webpack_public_path__ + "static/media/serious-man.64047028.svg";